// The glyphs of the approved mobile board mockup, drawn as its 24 x 24 stroke
// icons (2 px round line, no fill) so the phone board looks like the mockup
// rather than like the filled Material set the desktop header uses.

import type { ReactNode } from 'react';

interface IconProps {
    size?: number;
}

const strokeIcon =
    (paths: ReactNode, defaultSize: number) =>
    ({ size = defaultSize }: IconProps) => (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
            focusable="false"
            style={{ display: 'block', flexShrink: 0 }}
        >
            {paths}
        </svg>
    );

export const ChevronDownIcon = strokeIcon(<path d="M6 9l6 6 6-6" />, 18);
export const ChevronRightIcon = strokeIcon(<path d="M9 6l6 6-6 6" />, 20);
export const ArrowDownIcon = strokeIcon(<path d="M12 5v14M6 13l6 6 6-6" />, 22);
export const ArrowUpIcon = strokeIcon(<path d="M12 19V5M6 11l6-6 6 6" />, 22);
export const CloseIcon = strokeIcon(<path d="M6 6l12 12M18 6L6 18" />, 22);
export const InfoIcon = strokeIcon(
    <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 11v6M12 7.5v.5" />
    </>,
    22
);
export const ResetIcon = strokeIcon(
    <path d="M4 12a8 8 0 1 0 2.3-5.6M4 4v4h4" />,
    22
);
export const ShareIcon = strokeIcon(
    <>
        <path d="M8 12h8M12 8l4 4-4 4" />
        <rect x="3" y="4" width="18" height="16" rx="3" />
    </>,
    22
);
export const FiltersIcon = strokeIcon(
    <>
        <path d="M4 7h9M19 7h1M4 17h1M11 17h9" />
        <circle cx="16" cy="7" r="2.5" />
        <circle cx="8" cy="17" r="2.5" />
    </>,
    22
);
export const RetryIcon = strokeIcon(
    <path d="M20 12a8 8 0 1 1-2.3-5.6M20 4v4h-4" />,
    22
);

// Three filled dots in a column: the column options button.
export function MoreDotsIcon({ size = 22 }: IconProps) {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="currentColor"
            aria-hidden="true"
            focusable="false"
            style={{ display: 'block', flexShrink: 0 }}
        >
            <circle cx="12" cy="5" r="2" />
            <circle cx="12" cy="12" r="2" />
            <circle cx="12" cy="19" r="2" />
        </svg>
    );
}
